import { useMemo } from 'react';

export default function useSortedLotteriesTask(lotteryTasks) {
    const sortedLotteriesTask = useMemo(() => {
        let sorted = Object.entries(lotteryTasks).map(([uuid, data]) => ({
            uuid,
            ...data
        }));
        sorted.sort((a, b) => a.taskCondition - b.taskCondition);

        return sorted;
    }, [lotteryTasks]);

    return sortedLotteriesTask;
}
